/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import { SkeletonItem } from '@atlaskit/menu';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	wrapper: {
		borderColor: token('color.border', '#091E4224'),
		borderStyle: 'solid',
		borderWidth: token('border.width', '1px'),
		height: '312px',
		overflow: 'hidden',
		// @ts-ignore
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		"[data-testid='select-all-skeleton']": {
			marginBlock: token('space.0', '0px'),
			marginInline: token('space.050', '4px'),
			height: '48px',
		},
		// @ts-ignore
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		"[data-testid='team-member-skeleton']": {
			height: '48px',
		},
	},
});

const TeamMembersSkeleton = () => {
	return (
		<Box testId="testId-team-member-picker-skeleton" xcss={styles.wrapper}>
			<SkeletonItem isShimmering width="50%" testId="select-all-skeleton" />
			{[...Array(6)].map((_, index) => (
				<SkeletonItem key={index} hasAvatar isShimmering testId="team-member-skeleton" />
			))}
		</Box>
	);
};

export default TeamMembersSkeleton;
